import { render, staticRenderFns } from "./features.vue?vue&type=template&id=d8647e0a&scoped=true"
import script from "./features.vue?vue&type=script&lang=js"
export * from "./features.vue?vue&type=script&lang=js"
import style0 from "./features.vue?vue&type=style&index=0&id=d8647e0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8647e0a",
  null
  
)

export default component.exports